<template>
    <div class="page-title-area bg-11">
        <div class="container">
            <div class="page-title-content">
                <h2>RecoverPassword</h2>
                <ul>
                    <li>
                        <router-link to="/">
                            Home 
                        </router-link>
                    </li>
                    <li class="active">Recover Password</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageTitle'
}
</script>